import { render, staticRenderFns } from "./layout-nofooter.vue?vue&type=template&id=5fd963eb"
import script from "./layout-nofooter.vue?vue&type=script&lang=js"
export * from "./layout-nofooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports